import { render } from "./tab-friend.vue?vue&type=template&id=88351536"
import script from "./tab-friend.vue?vue&type=script&lang=js"
export * from "./tab-friend.vue?vue&type=script&lang=js"

import "./tab-friend.vue?vue&type=style&index=0&id=88351536&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__